var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconoX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.1876,
    cy: 12.1876,
    r: 12.1876,
    fill: "#646363"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0238 12.6226C9.3492 10.4211 7.7284 8.28575 6 6.00496C7.31816 6.00496 8.48163 5.98513 9.64511 6.02479C9.84687 6.0314 10.0823 6.28923 10.2369 6.48095C11.2121 7.73043 12.1738 8.99973 13.1826 10.3285C14.4066 9.0394 15.597 7.82298 16.7268 6.56028C17.1505 6.08429 17.5877 5.89257 18.3275 6.06446C16.7739 7.72381 15.2607 9.33028 13.6937 11.0029C15.4356 13.2969 17.164 15.5711 19 17.9841C17.6751 17.9841 16.4847 18.0039 15.3011 17.9642C15.1061 17.9576 14.8841 17.6733 14.7362 17.475C13.6803 16.1132 12.6446 14.7381 11.5416 13.2903C10.1899 14.7182 8.88515 16.0735 7.61407 17.4684C7.19038 17.9312 6.75323 18.1295 6.0538 17.9113C7.71495 16.1528 9.34247 14.4141 11.0238 12.6226ZM7.73513 6.85778C7.92344 7.13544 8.07139 7.37343 8.24625 7.59821C10.479 10.5335 12.7589 13.4291 14.9177 16.4173C15.5701 17.323 16.2897 17.2965 17.3052 17.1841C17.0833 16.8668 16.9286 16.6354 16.7605 16.4173C14.5411 13.5018 12.2882 10.6194 10.1293 7.66432C9.47698 6.77183 8.77755 6.62639 7.73513 6.85778Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoX);
export default __webpack_public_path__ + "static/media/icono-x.fee4c64c753a72061f3ed49ec471824a.svg";
export { ForwardRef as ReactComponent };